import api from './api';
import { API_ENDPOINTS } from '../constants';

export interface Font {
  id: number;
  name: string;
  file?: {
    id?: number;
    path: string;
    contentType?: string;
    originalFileName?: string;
  };
}

export const fontService = {
  /** GET /api/v1/fonts — список шрифтов для шаблонов промокодов */
  getFonts: async (): Promise<Font[]> => {
    const { data } = await api.get<Font[]>(API_ENDPOINTS.FONTS);
    return Array.isArray(data) ? data : [];
  },
};
